'use client'
const hasAtomicStatusCapability = (capabilities, chainId) => {
    if (!(capabilities === null || capabilities === void 0 ? void 0 : capabilities[chainId])) {
        return false;
    }
    const chainCapabilities = capabilities[chainId];
    return Boolean(chainCapabilities['atomic'] &&
        (chainCapabilities['atomic'].status === 'ready' ||
            chainCapabilities['atomic'].status === 'supported'));
};

export { hasAtomicStatusCapability };
